import { VehicleInfoOperations } from '../../services/VehicleInfoOperations';
const selectedInfoUpdated = (state, action) => {
    const { vehicleSelectionHierarchyLabel, vehicleInfoEntry } = action.payload;
    const newState = new Map(state);
    return VehicleInfoOperations.updateSelectedInfoEntries(newState, vehicleSelectionHierarchyLabel, vehicleInfoEntry);
};
export default selectedInfoUpdated;
//# sourceMappingURL=selectedInfoUpdated.js.map